import { createApp, h } from 'vue'
import HiLoading from './HiLoading.vue'

export default {
  install(app) {
    const mountNode = document.createElement('div')
    document.body.appendChild(mountNode)

    const loadingApp = createApp({
      render() {
        return h(HiLoading, { ref: 'loading' })
      }
    })

    const rootInstance = loadingApp.mount(mountNode)
    const loadingComponent = rootInstance.$refs.loading
	// 
	window.$HiLoading = loadingComponent

    app.config.globalProperties.$HiLoading = {
      show: (msg) => loadingComponent.show(msg),
      hide: () => loadingComponent.hide(),
    }

    // 主应用卸载时清理
    const originalUnmount = app.unmount
    app.unmount = function (...args) {
      loadingApp.unmount()
      document.body.removeChild(mountNode)
      return originalUnmount.call(this, ...args)
    }
  }
}